export default "__VITE_ASSET__DRKfebeC__"